import React, { useState, createContext, useEffect, useContext } from "react";

export const NavDrawerContext = createContext();

export const NavDrawerProvider = (props) => {
  const [navDrawerOpen, setNavDrawerOpen] = useState(true);

  const closeNavDrawer = () => {
    setNavDrawerOpen(false);
  };
  const openNavDrawer = () => {
    setNavDrawerOpen(true);
  };

  return (
    <NavDrawerContext.Provider
      value={{
        navDrawerOpen,
        closeNavDrawer,
        openNavDrawer,
      }}
    >
      {props.children}
    </NavDrawerContext.Provider>
  );
};
